<template>
  <div>
    <el-row :gutter="20" class="search-and-add-row">
      <el-form :model="queryParams" style="max-width: 500px; width: 100%;">
        <!-- 机构选择器 -->
        <el-form-item label="机构" label-width="80px">
          <el-select
              v-model="queryParams.OrganizationID"
              placeholder="请选择机构"
              size="small"
              @change="fetchData"
              style="width: 100%;"
          >
            <el-option
                v-for="org in organizationOptions"
                :key="org.organizationID"
                :label="org.orgName"
                :value="org.organizationID"
            />
          </el-select>
        </el-form-item>

        <!-- 培训计划选择项 -->
        <el-form-item label="培训计划" label-width="80px">
          <el-select
              v-model="queryParams.trainingPlanId"
              placeholder="请选择培训计划"
              size="small"
              @change="fetchData"
              style="width: 100%;"
          >
            <el-option
                v-for="plan in trainingPlanOptions"
                :key="plan.planId"
                :label="plan.planName"
                :value="plan.planId"
            />
          </el-select>
        </el-form-item>

        <!-- 重置按钮 -->
        <el-form-item>
          <el-button size="small" @click="resetQuery" style="width: 100%;">
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <!-- 添加考试按钮 -->
    <el-row style="margin-bottom: 20px;">
      <el-button type="primary" size="small" @click="openAddDialog">
        添加考试
      </el-button>
    </el-row>

    <!-- 引用 testadd 组件 -->
    <testadd
        v-if="showthis"
        :plans="plans1"
        :questions="questions"
        :organizationID="queryParams.OrganizationID"
        @close="closeDialog"
    />

    <!-- 数据表格 -->
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="id" label="编号" width="60" />
      <el-table-column prop="trainingPlanId" label="培训计划编号" width="140" />
      <el-table-column prop="organizationId" label="组织编号" width="140" />
      <el-table-column prop="orgName" label="组织名字" width="140" />
      <el-table-column prop="question_ids" label="问题编号" />
      <el-table-column prop="createdAt" label="创建时间" width="180" />
      <el-table-column prop="updatedAt" label="更新时间" width="180" />
      <el-table-column label="操作" width="200">
        <template #default="scope">
          <el-button type="primary" size="small" @click="editRecord(scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="deleteRecord(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
        :current-page="pagination.page"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next"
    />

    <!-- 编辑弹窗 -->
    <el-dialog v-model="editDialogVisible" title="编辑考试" width="50%">
      <el-form :model="editForm" :rules="rules" ref="editFormRef" label-width="120px">
        <el-form-item label="培训计划编号" prop="trainingPlanId">
          <el-input v-model="editForm.trainingPlanId" />
        </el-form-item>
        <el-form-item label="组织编号" prop="OrganizationId">
          <el-input v-model="editForm.OrganizationId" />
        </el-form-item>
        <el-form-item label="问题编号" prop="questionIds">
          <el-input v-model="editForm.question_ids" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveEdit">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import axios from "@/axios";
import testadd from '@/components/ManageView/TestView.vue'; // 引入子组件

export default {
  components: {
    testadd, // 注册子组件
  },
  data() {
    return {
      showthis: false, // 控制子组件显示
      // 查询参数
      queryParams: {
        OrganizationID: 1, // 机构 ID
        trainingPlanId: 0, // 培训计划 ID
      },
      // 机构选项
      organizationOptions: [],
      // 培训计划选项
      trainingPlanOptions: [],
      // 题目列表
      questions: [],
      plans1:[],
      // 表格数据
      tableData: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      editDialogVisible: false,
      editForm: {},
      rules: {
        trainingPlanId: [{ required: true, message: "请输入培训计划编号", trigger: "blur" }],
        OrganizationId: [{ required: true, message: "请输入组织编号", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 获取数据
    fetchData() {
      const { page, pageSize } = this.pagination;
      const { OrganizationID, trainingPlanId } = this.queryParams;

      // 获取机构数据
      axios
          .get("/organization/list")
          .then((response) => {
            this.organizationOptions = response.data.data;
          })
          .catch((error) => {
            console.error("获取机构数据失败:", error);
            ElMessage.error("获取机构数据失败");
          });

      // 获取培训计划数据
      axios
          .get("/Manage/plans", { params: { OrganizationID, page: 0, size: 1000 } })
          .then((response) => {
            this.trainingPlanOptions = response.data.data;
          })
          .catch((error) => {
            console.error("获取培训计划失败:", error);
            ElMessage.error("获取培训计划失败");
          });

      // 获取考试数据
      axios
          .get("/Manage/exam", {
            params: { OrganizationID, trainingPlanId, page, pageSize },
          })
          .then((res) => {
            this.tableData = res.data.data.map((item) => {
              return {
                ...item,
                orgName:   this.organizationOptions.find((org) => org.organizationID === item.organizationId).orgName,
                question_ids: item.question_ids || [], // 确保 question_ids 是数组
              };
            });
            this.pagination.total = res.data.total;
          })
          .catch(() => {
            ElMessage.error("获取数据失败");
          });

      // 获取题目数据
      axios
          .get("/Manage/questions", { params: { OrganizationID } })
          .then((response) => {
            this.questions = response.data.data;
          })
          .catch((error) => {
            console.error("获取题目失败:", error);
            ElMessage.error("获取题目失败");
          });
    },
    getplans1(){

      axios.get('/Manage/plans1',{params:{
          OrganizationID:this.queryParams.OrganizationID
        }}).then(response => {
        if(response.data.success)
          this.plans1=response.data.data;
        else {
          ElMessage.error(response.data.errorMsg);
        }
      }).catch(error => {
        ElMessage.error("获取计划列表失败");
      })
    },

    // 重置查询条件
    resetQuery() {
      this.queryParams.OrganizationID = 0;
      this.queryParams.trainingPlanId = 0;
      this.fetchData();
    },

    // 打开添加考试弹窗
    openAddDialog() {
      this.showthis = true; // 显示子组件
    },

    // 关闭子组件弹窗
    closeDialog() {
      this.showthis = false; // 隐藏子组件
      this.fetchData(); // 刷新表格数据
    },

    // 编辑记录
    editRecord(row) {
      this.editForm = { ...row };
      if (Array.isArray(this.editForm.question_ids)) {
        this.editForm.question_ids = this.editForm.question_ids.join(", ");
      }
      this.editDialogVisible = true;
    },

    // 保存编辑
    saveEdit() {
      this.$refs.editFormRef.validate((valid) => {
        if (valid) {
          // 将 question_ids 从逗号分隔的字符串转化为数组
          if (typeof this.editForm.question_ids === "string") {
            this.editForm.question_ids = this.editForm.question_ids
                .split(",")
                .map((id) => id.trim());
          }

          axios
              .post("/Manage/exam", this.editForm)
              .then((response) => {
                if (response.data.success) {
                  ElMessage.success("保存成功");
                  this.editDialogVisible = false;
                  this.fetchData();
                } else {
                  ElMessage.error(response.data.errorMsg);
                }
              })
              .catch(() => {
                ElMessage.error("保存失败");
              });
        }
      });
    },

    // 分页变化
    handlePageChange(page) {
      this.pagination.page = page;
      this.fetchData();
    },

    // 每页显示数量变化
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.fetchData();
    },

    // 删除记录
    deleteRecord(id) {
      axios
          .delete(`/Manage/exam/${id}`)
          .then((response) => {
            if (response.data.success) {
              ElMessage.success("删除成功");
              this.fetchData();
            } else {
              ElMessage.error(response.data.errorMsg);
            }
          })
          .catch(() => {
            ElMessage.error("删除失败");
          });
    },
  },

  created() {
    // 初始化数据
    this.fetchData();

    this.getplans1()
  },
};
</script>

<style scoped>
.search-and-add-row {
  margin-bottom: 20px;
}
</style>